import * as React from "react";
import { Search, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { ICON_SIZES } from "@/lib/icon-sizes";

export interface PanelSearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
  inputClassName?: string;
}

/**
 * Unified search control for task pane panels (shared focus ring, border, height).
 */
export function PanelSearchField({
  value,
  onChange,
  placeholder,
  className,
  inputClassName,
}: PanelSearchFieldProps) {
  return (
    <div
      className={cn(
        "flex h-9 min-w-0 flex-1 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 shadow-sm transition-all",
        "focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/10",
        className
      )}
    >
      <Search size={ICON_SIZES.sm} className="shrink-0 text-slate-400" aria-hidden />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn(
          "min-w-0 flex-1 border-none bg-transparent text-xs text-slate-900 outline-none placeholder:text-slate-400",
          inputClassName
        )}
        autoComplete="off"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          className="flex shrink-0 items-center rounded p-0.5 text-slate-400 transition-colors hover:text-slate-700"
          title="Clear search"
        >
          <X size={ICON_SIZES.sm} />
        </button>
      ) : null}
    </div>
  );
}
